import React, { useState } from 'react';
import { Row, Col, Button } from 'antd'
import { COLOR, FONT } from '../constants'
import styled from 'styled-components';
import useResponsive from '../hooks/useResponsive'
import TNContent from './TNContent';

const StartSection = styled.a`
  &:hover, &:active, &:focus {
    color: ${COLOR.textSecondary} !important;
    cursor: pointer;
  }
  border-bottom: 1px solid ${COLOR.menuText};
  color: #000;
`

const StyledButton = styled(Button)`
  width: 100%;
  &:hover, :focus {
    background-color: ${COLOR.content} !important;
    border: 3px solid #000000 !important;
    box-shadow: 6px 7px 0px #000000;
    border-radius: 8px;
  }
  border: 3px solid transparent !important;
`


const Landing = ({
  whitelistModal,
  setWhitelistModal
}) => {
  const { isMobile, isTablet } = useResponsive();
  const [hover, setHover] = useState(false)
  return (
    <TNContent maxWidth={1920}>
      <Row
        align='middle'
        justify='center'
        style={{
          backgroundImage: isMobile ? "url('./assets/floor_mobile.png')" : "url('./assets/floor.png')",
          backgroundPosition: 'bottom',
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          minHeight: isMobile || isTablet ? '70vh' : '100vh',
          width: '100%',
          textAlign: 'center',
          paddingTop: isMobile ? 80 : 200,
          marginTop: -1,
        }}>
        <Col xs={20} sm={20} md={24} lg={24} style={{ ...FONT.h3 }}>
          <Row justify="center" align='middle' gutter={[0, { xs: 12, sm: 12, md: 24, lg: 24 }]}>
            <Col span={24} style={isMobile ? FONT.h6 : FONT.h3}> Welcome to</Col>
            <Col span={24} style={isMobile ? FONT.h5 : FONT.h2}>
              {!isMobile && <img src="./assets/star.svg" alt="" style={{ width: 52, marginRight: 16 }} />}
              technine {' '}
              <span style={{ WebkitTextStroke: isMobile ? '1px #000' : '2px #000', color: '#FFF0D2' }}>NFT</span>
              {' '}
              Collection -
              {' '}
              <span style={{ WebkitTextStroke: isMobile ? '1px #000' : '2px #000', color: '#FFF0D2' }}>Shiba9</span>
              {!isMobile && <img src="./assets/star.svg" alt="" style={{ width: 52, marginLeft: 16 }} />}
            </Col>
            <Col span={24} style={isMobile ? { ...FONT.captionText } : { ...FONT.text, marginBottom: 20 }}>
              * NFT minting hands-on experience powered by NineBlocks <br /> Celebrating technine 3 year anniversary with 3,333 free NFTs
            </Col>

            <Col span={24}>
              <StartSection
                href="#"
                onClick={() => setWhitelistModal(true)}
              // onMouseEnter={() => { setHover(true) }}
              // onMouseLeave={() => { setHover(false) }}
              >
                <span style={isMobile ? { ...FONT.h6, color: COLOR.heading } : { ...FONT.h5, color: COLOR.heading }}>(1) Get Whitelist Token</span>
                <img src={'./assets/click.png'} alt="" style={{ width: 28, marginLeft: 5 }} />
              </StartSection>
            </Col>
            <Col span={24}>
              <StartSection
                href="#collection-mint"
              // onMouseEnter={() => { setHover(true) }}
              // onMouseLeave={() => { setHover(false) }}
              >
                <span style={isMobile ? { ...FONT.h6, color: COLOR.heading } : { ...FONT.h5, color: COLOR.heading }}>(2) Start Minting !</span>
                <img src={'./assets/click.png'} alt="" style={{ width: 28, marginLeft: 5 }} />
              </StartSection>
            </Col>
          </Row>
          <Row justify='center'>
            <Col span={24}>
              {isMobile ?
                <img src="./assets/landing_nft_mobile.png" alt="" style={{ width: '100%' }} />
                :
                <img src="./assets/landing_nft.png" alt="" style={{ width: '100%' }} />
              }
            </Col>
          </Row>
        </Col>
      </Row >
    </TNContent>
  )
}

export default Landing;